import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import {
  BottomNavigation,
  BottomNavigationAction,
  SwipeableDrawer,
  IconButton,
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import InfoIcon from '@material-ui/icons/Info'
import TaskIcon from '@material-ui/icons/Done'
import { CalendarCheck } from 'mdi-material-ui'
import {
  toggleBottomNav,
  clickBottomNavigation,
} from 'actions/campaign/addOrEdit'
import General from '../RightMenu/General'
import EventGoals from '../RightMenu/EventGoals'
import Tasks from '../RightMenu/Tasks'
import classNames from 'classnames'

export default connect(
  state => ({
    bottomNavigation: state.campaign.addOrEdit.bottomNavigation.index,
    navDisplayed: state.campaign.addOrEdit.bottomNavigation.displayed,
  }),
  dispatch =>
    bindActionCreators({ toggleBottomNav, clickBottomNavigation }, dispatch),
)(
  withStyles(theme => ({
    expansionPanel: {
      position: 'fixed',
      width: '100%',
      boxShadow: '0 -16px 5px -2px rgba(0,0,0,0.12)',
      left: 80,
      paddingRight: 80,
      [theme.breakpoints.down('xs')]: {
        left: 0,
        paddingRight: 0,
      },
    },
    bottomNavExpanded: {
      margin: 0,
    },
    panelSummary: {
      justifyContent: 'space-between',
      flexGrow: 0,
      padding: 0,
    },
    panelSummaryExpanded: {
      margin: '0 !important',
      minHeight: '0 !important',
    },
    panelSummaryContent: {
      margin: 0,
    },
    panelDetails: {
      padding: '7px',
      minHeight: 447,
    },
    bottomNav: {
      position: 'absolute',
      top: 0,
      backgroundColor: theme.palette.secondary.main,
      color: '#fff',
      width: '100%',
      // left: 0,
      zIndex: 3,
    },
    bottomNavActionSelected: {
      color: '#fff !important',
      backgroundColor: '#003a71',
      fontSize: '0.75rem !important',
      paddingTop: '0 !important',
    },
    bottomNavLabel: {
      color: '#fff',
    },
    drawer: {
      height: 447,
      flexShrink: 0,
    },
    drawerOpen: {
      boxShadow: '0 -16px 5px -2px rgba(0,0,0,0.12)',
      height: 529,
      borderTop: 0,
    },
    drawerClose: {
      borderTop: 0,
    },
    backdropRoot: {
      display: 'none',
    },
    root: {
      top: 'auto',
    },
  }))(
    ({
      bottomNavigation,
      navDisplayed,
      classes,
      toggleBottomNav,
      clickBottomNavigation,
    }) => {
      const bottomNavStyle = { width: '100%', margin: '56px 0 0 0' }
      const listStyle = { padding: '65px 12px 12px' }

      const bottomNav = () => {
        switch (bottomNavigation) {
          case 1:
            return <General style={bottomNavStyle} />
          case 2:
            return (
              <div style={listStyle}>
                <EventGoals style={bottomNavStyle} />
              </div>
            )
          case 3:
            return (
              <div style={listStyle}>
                <Tasks style={bottomNavStyle} />
              </div>
            )
          default:
            return <General style={bottomNavStyle} />
        }
      }

      return (
        <SwipeableDrawer
          anchor="bottom"
          open={navDisplayed}
          onClose={() => toggleBottomNav(false)}
          onOpen={() => toggleBottomNav(true)}
          className={classNames(classes.drawer, {
            [classes.drawerOpen]: navDisplayed,
            [classes.drawerClose]: !navDisplayed,
          })}
          classes={{
            root: classes.root,
            paper: classNames({
              [classes.drawerOpen]: navDisplayed,
              [classes.drawerClose]: !navDisplayed,
            }),
          }}
          disableBackdropTransition
          disableSwipeToOpen={false}
          ModalProps={{
            BackdropProps: { classes: { root: classes.backdropRoot } },
          }}
        >
          <BottomNavigation
            className={classes.bottomNav}
            onChange={(e, val) => {
              e.stopPropagation()
              toggleBottomNav(true)
              clickBottomNavigation(val)
            }}
            value={bottomNavigation}
          >
            <IconButton
              disableRipple
              disableTouchRipple
              onClick={() => toggleBottomNav()}
            >
              {navDisplayed ? (
                <ExpandMoreIcon style={{ color: '#fff' }} />
              ) : (
                <ExpandLessIcon style={{ color: '#fff' }} />
              )}
            </IconButton>
            <BottomNavigationAction
              classes={{
                selected: classes.bottomNavActionSelected,
                label: classes.bottomNavLabel,
              }}
              label="General"
              icon={<InfoIcon style={{ color: '#fff' }} />}
              showLabel
            />
            <BottomNavigationAction
              classes={{
                selected: classes.bottomNavActionSelected,
                label: classes.bottomNavLabel,
              }}
              label="Event Goals"
              icon={<CalendarCheck style={{ color: '#fff' }} />}
              showLabel
            />
            <BottomNavigationAction
              classes={{
                selected: classes.bottomNavActionSelected,
                label: classes.bottomNavLabel,
              }}
              label="Tasks"
              icon={<TaskIcon style={{ color: '#fff' }} />}
              showLabel
            />
          </BottomNavigation>
          {bottomNav()}
        </SwipeableDrawer>
      )
    },
  ),
)
